/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled      from 'styled-components';
import { Colours } from '../../../styles/variables';

/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledIconLinkIcon = styled.div`
  color: ${props => props.iconColour || Colours.White};
  margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledIconLinkIcon/index.js